module.exports = __webpack_public_path__ + "img/tra-icon.16cda864.svg";